@if (pageMode) {
<ion-header>
  <ion-toolbar>
    <ion-button slot="start" fill="clear" color="dark" (click)="close()">Cancel</ion-button>
    <ion-title>ID Verification</ion-title>
  </ion-toolbar>
</ion-header>
}

<ion-content [class.ion-padding]="pageMode">
  @if (template?.identityVerificationSettings) {
  <div class="flex flex-col items-start justify-between bg-white p-4 rounded-sm mb-2">

    <div class="flex flex-col items-start justify-between w-full mt-2">
      <h4 class="text-sm font-bold m-0 text-gray-700">Indian Users</h4>
      @for (row of documentRows; track row.docType) {
      <div class="w-full flex flex-col md:flex-row md:items-center md:justify-between gap-2 border-b border-gray-200 py-4">
        <ion-checkbox labelPlacement="end" color="dark" [checked]="isDocumentAccepted(row.docType)"
          (ionChange)="setDocumentAccepted(row.docType, $any($event).detail.checked)">{{ row.label }}</ion-checkbox>
        <div class="flex flex-row flex-wrap items-center gap-2 pl-9"
          [class.opacity-40]="!isDocumentAccepted(row.docType)"
          [class.pointer-events-none]="!isDocumentAccepted(row.docType)">
          @for (source of getSourcesForDocument(row.docType); track source) {
          <button type="button" class="source-pill" [class.source-pill--selected]="isSourceSelected(row.docType, source)"
            (click)="toggleSource(row.docType, source)">
            @if (isSourceSelected(row.docType, source)) {
            <ion-icon class="size-4" name="checkmark-circle"></ion-icon>
            } @else {
            <ion-icon class="size-4" name="ellipse-outline"></ion-icon>
            }
            {{ sourceLabel(source) }}
          </button>
          }
        </div>
      </div>
      }
    </div>

    <div class="flex flex-col items-start justify-between w-full mt-4">
      <h4 class="text-sm font-bold m-0 text-gray-700">Non-Indian Users</h4>
      <div class="w-full flex flex-col md:flex-row md:items-center md:justify-between gap-2 py-2">
        <ion-checkbox labelPlacement="end" color="dark" [checked]="true"
          [disabled]="isDocumentSelectionDisabled(passportRow.docType)">{{ passportRow.label }}</ion-checkbox>
        <div class="flex flex-row flex-wrap items-center gap-2 pl-9">
          @for (source of getSourcesForDocument(passportRow.docType); track source) {
          @if (canDeselectSource(passportRow.docType, source)) {
          <button type="button" class="source-pill"
            [class.source-pill--selected]="isSourceSelected(passportRow.docType, source)"
            (click)="toggleSource(passportRow.docType, source)">
            @if (isSourceSelected(passportRow.docType, source)) {
            <ion-icon class="size-4" name="checkmark-circle"></ion-icon>
            } @else {
            <ion-icon class="size-4" name="ellipse-outline"></ion-icon>
            }
            {{ sourceLabel(source) }}
          </button>
          } @else {
          <span class="source-pill source-pill--selected source-pill--disabled">
            <ion-icon class="size-4" name="checkmark-circle"></ion-icon>
            {{ sourceLabel(source) }}
          </span>
          }
          }
        </div>
      </div>
    </div>
  </div>
  }
</ion-content>

@if (pageMode) {
<ion-footer>
  <page-action>
    <super-button sxWidth="full" (click)="save()">Save</super-button>
  </page-action>
</ion-footer>
}
